import { useState, useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { cn } from '@shared/lib';
import { buttonVariants } from '@shared/ui/button';
import { Separator } from '@shared/ui/separator';
import { isNewTabItemTitle, isStripeLink, type NavItem } from '../constants';

type SideNavProps = {
  items: NavItem[];
  isOpen: boolean;
  setOpen?: (open: boolean) => void;
  className?: string;
};

//SideNav is called withing Mobile && Sidebar to render out items
export const SideNav = ({
  items,
  isOpen,
  setOpen,
  className,
}: SideNavProps) => {
  const [openItem, setOpenItem] = useState('');
  const [lastOpenItem, setLastOpenItem] = useState('');
  const location = useLocation();

  useEffect(() => {
    if (isOpen) {
      setOpenItem(lastOpenItem);
    } else {
      setLastOpenItem(openItem);
      setOpenItem('');
    }
  }, [isOpen]);

  return (
    <nav className="space-y-2">
      {items.map((item) => (
        <Fragment key={item.title}>
          <Link
            to={item.href}
            target={
              isStripeLink(item.title) || isNewTabItemTitle(item.title)
                ? '_blank'
                : '_self'
            }
            onClick={() => {
              if (setOpen) setOpen(false);
            }}
            className={cn(
              buttonVariants({ variant: 'ghost' }),
              'group relative flex h-12 justify-start',
              location.pathname === item.href &&
                'bg-muted font-bold transition-all hover:bg-muted'
            )}
          >
            <item.icon className={cn('h-5 w-5', item.color)} />
            <span
              className={cn(
                'absolute left-14 text-base duration-100',
                !isOpen && className
              )}
            >
              {item.title}
            </span>
          </Link>
          {item.endOfSection && <Separator className="m-auto w-11/12" />}
        </Fragment>
      ))}
    </nav>
  );
};
